import Dialog from "@mui/material/Dialog";
import {Box, Button, IconButton, MenuItem, Select, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import FormControl from "@mui/material/FormControl";
import DialogActions from "@mui/material/DialogActions";
import {useState} from "react";

export default function CategoryDialog({rows, open, closeCategoryDialog, onSelectCategory, submitSaveAd}) {
    const [categoryDescSelected, setCategoryDescSelected] = useState("Seleccionar categoria")
    const onChange = (e) => {
        if (onSelectCategory) {
            onSelectCategory(e.target.value)
        }
    }

    return (
        <Dialog open={open} onClose={closeCategoryDialog}>
            <Box position={'relative'}>
                <IconButton
                    size="small"
                    sx={{position: 'absolute', right: 5, top: 5}}
                    onClick={closeCategoryDialog}>
                    <CloseIcon/>
                </IconButton>
            </Box>
            <Typography paddingX={3} pt={3} pb={2} variant="h5">
                Asignar categoría
            </Typography>
            <DialogContent>
                <Box sx={{minWidth: 320, maxHeight: 420}}>
                    <FormControl fullWidth size="small">
                        <Select
                            displayEmpty
                            onChange={onChange}
                            value={categoryDescSelected}
                            variant="outlined"
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em>categoryDescSelected</em>;
                                }
                                return categoryDescSelected;
                            }
                            }
                        >
                            {rows && rows.map(category => (
                                <MenuItem sx={{color: 'black'}} id={category.id} value={category.FK_Category_Code}
                                          onClick={(e) => {
                                              setCategoryDescSelected(e.target.innerText)
                                          }}>
                                    {category.Category_Name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{paddingBottom: 3, paddingRight: 3}}>
                <Button variant="contained" onClick={submitSaveAd}>
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
}